import AuthorizationManager from "./AuthorizationManager";
const API_URL = "/transparency-portal";

const authorizationManager = AuthorizationManager.instance;

export default class NetworkManager {

    static UNAUTHORIZED_ERROR = new Error("Unauthorized network request!");

    /**
     * @returns {NetworkManager}
     */
    static get instance() {
        if (NetworkManager._instance === undefined) {
            NetworkManager._instance = new NetworkManager();
        }

        return NetworkManager._instance;
    }

    /**
     * @param { "/forumEntry" | "/allShortEntries" | "/topicInfo" | "/fileUploadUrls" | "/uploadForumEntry" | "/checkLogin" } path The relative path of the ressource. Must start with "/"
     * @param { "GET" | "POST" } method The HTTP request method
     * @param body The request body to append
     */
    async fetch( path, method = "GET", params = undefined, body = undefined ) {

        console.info( `Fetching on ressoure "${API_URL + path}" with method "${method}"` );

        const captchaKey = authorizationManager.captchaKey;

        const headers = {};
        if (captchaKey) headers.Authorization = "Bearer " + captchaKey;

        // prepare params
        const paramsString = params ? "?" + Object.entries(params).map( kv => escape(kv[0]) + (kv[1] !== undefined ? "="+escape(kv[1]) : "") ).join("&") : "";

        if ( typeof body === "object" && body !== undefined ) headers["Content-Type"] = "application/json";

        // execute fetch
        const response = await fetch( API_URL + path + paramsString, {
            method,
            body: typeof body === "object" && body !== undefined ? JSON.stringify(body) : body,
            headers: headers
        });

        if (response.headers.has("err")) throw new Error(response.headers.get("err"));
        if (response.status === 401) {
            try {
                console.error(`Unauthorized: ${await response.text()}`);
            } catch(e) {}
            throw NetworkManager.UNAUTHORIZED_ERROR;
        };
        if (!response.ok) throw new Error(`The response was not 200 (OK) but ${response.status}`);
        if (response.headers.has("Content-Type") && response.headers.get("Content-Type").startsWith("application/json")) return await response.json();
        
    }

}